import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex mt-20" }
const _hoisted_6 = { class: "relative w-full" }
const _hoisted_7 = {
  class: "c-button c-button--secondary-current-color block flex-shrink-0 ml-10 self-start -mt-8 md:-mt-3",
  type: "submit"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex flex-col items-end mt-20 sm:flex-row" }
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  class: "c-button c-button--secondary-current-color block flex-shrink-0 ml-10 -mt-3 sm:self-start",
  type: "submit"
}
const _hoisted_17 = {
  key: 2,
  class: "text-center"
}
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Recaptcha = _resolveComponent("Recaptcha")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "wrapperRef",
    class: "mx-auto w-full flex flex-col justify-center py-20 px-25 mb-15 md:mb-30 sm:w-4/5 lg:w-3/5 lg:pb-20 xl:w-1/2",
    style: _normalizeStyle({ 'min-height': _ctx.initialWrapperHeight })
  }, [
    _createVNode(_component_Form, {
      class: "flex flex-col mt-30 md:mt-gutter",
      onSubmit: _ctx.verifyRecaptcha
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(_component_Recaptcha, {
          ref: "recaptcha",
          modelValue: _ctx.recaptchaKey,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recaptchaKey) = $event)),
          onVerify: ($event: any) => (handleSubmit(_ctx.submitSubscription))
        }, null, 8, ["modelValue", "onVerify"]),
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.currentSignUpStep === 1)
              ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                  (_ctx.content.title)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.content.title), 1))
                    : _createCommentVNode("", true),
                  (_ctx.content.step1Text)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: "text-center current-font-styling-on-child-elements magic-line-on-child-links mt-10",
                        innerHTML: _ctx.content.step1Text
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                  (_ctx.content.step1SmallText)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        class: "o-text-caption text-center current-font-styling-on-child-elements magic-line-on-child-links mt-10",
                        innerHTML: _ctx.content.step1SmallText
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_InputText, {
                        name: "email",
                        type: "email",
                        rules: "required|email|max:80",
                        label: _ctx.labels.email,
                        class: "text-current-color",
                        maxlength: "80"
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.content.step1ButtonText), 1)
                  ])
                ]))
              : (_ctx.currentSignUpStep === 2)
                ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                    (_ctx.content.step2Title)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(_ctx.content.step2Title), 1))
                      : _createCommentVNode("", true),
                    (_ctx.content.step2Text)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "text-center mt-10",
                          innerHTML: _ctx.content.step2Text
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_InputText, {
                        name: "name",
                        type: "text",
                        rules: "required|max:100",
                        label: _ctx.labels.firstName,
                        class: "text-current-color flex-1 w-full sm:mr-10"
                      }, null, 8, ["label"]),
                      (_ctx.storeList.length === 1)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            class: "hidden",
                            name: "storeId",
                            value: _ctx.storeList[0].id,
                            type: "text",
                            "aria-hidden": "true",
                            "aria-disabled": "true",
                            disabled: "true"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.storeList.length > 1)
                        ? (_openBlock(), _createBlock(_component_InputSelect, {
                            key: 1,
                            label: _ctx.labels.preferredBoliaStore,
                            class: "text-current-color flex-1 w-full sm:mr-10",
                            name: "storeId"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.labels.choosePreferredBoliaStore), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeList, (store) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: store.id,
                                  value: store.id
                                }, _toDisplayString(store.description), 9, _hoisted_13))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (_ctx.showCountrySelector)
                        ? (_openBlock(), _createBlock(_component_InputSelect, {
                            key: 2,
                            label: _ctx.labels.chosenCountry,
                            class: "text-current-color flex-1 w-full sm:w-auto",
                            name: "countryCode"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.labels.chooseCountry), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: country.code,
                                  value: country.code
                                }, _toDisplayString(country.name), 9, _hoisted_15))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.content.step2ButtonText), 1)
                    ])
                  ]))
                : (_ctx.currentSignUpStep === 3)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.content.step3Title), 1),
                      _createElementVNode("p", {
                        class: "mt-10",
                        innerHTML: _ctx.content.step3Text
                      }, null, 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ], 4))
}